import React,{useContext,useEffect, useState} from 'react'
import {HeadTableLeads, RowLeadsAssignmanager } from "../../ui-components";
import LeadsContext from '../../context/leads';
import moment from "moment";


function AssignManager({onToggleTab,setAssignLead, order, idBranch}) {  
  const {LeadsManagers, models, Subs} = useContext(LeadsContext)

  useEffect(()=>{
    LeadsManagers(3, order, idBranch);
    Subs();
  },[order])

  //console.log(moment("05-04-2023 11:03","DD-MM-YYYY HH:mm").fromNow().slice(0,2))

  return (
    <div className="overflow-x-scroll py-2">
    <HeadTableLeads type="assignmanager"/>
    {models?.map((lead, index) => (
      index % 2 == 0 ?
      <RowLeadsAssignmanager type={(moment(lead.dateManager,"DD-MM-YYYY HH:mm").add(1, 'days').fromNow().slice(0,2) === "in") ? "onTime" : "delayed"} key={lead.id} leads={lead} overrides={{
        Button45345871:{
          onClick: () =>{
            onToggleTab(6)
            setAssignLead(lead)
          }
        },
          Button45345865:{
            onClick: () =>{
              onToggleTab(5)
              setAssignLead(lead)
            }
          }
      }} /> :
      <RowLeadsAssignmanager key={lead.id} leads={lead} type={(moment(lead.dateManager,"DD-MM-YYYY HH:mm").add(1, 'days').fromNow().slice(0,2) === "in") ? "onTime" : "delayed"} overrides={{
        "Frame 20797":{backgroundColor: "#ffffff"},
        Button45345871:{
          onClick: () =>{
            onToggleTab(6)
            setAssignLead(lead)
          }
      },
      Button45345865:{
        onClick: () =>{
          onToggleTab(5)
          setAssignLead(lead)
        }
      }
      }}/> 
    ))}
  </div>

  )
}

export default AssignManager